/*import Logo from '../images/logo/logo-krug.png';*/
import Firma from '../images/smesko/gorskismesko-text.png';

/*import Dropdown from './dropdown';*/

function Header() {

    return (

        <div className='header'>

            {/*<table>

                <tbody>

                    <tr className=''>*/}

                        {/*<td>

                            <img src={Logo} className='logo' width='35%' alt=''/>

                        </td>*/}

                        {/*<td>*/}

                            <img src={Firma} className='responsive' alt='' />

                        {/*</td>*/}

                        {/*<td>

                            <Dropdown />

                        </td>*/}

                    {/*</tr>

                </tbody>

            </table>*/}

            {/*<img src={Firma} className='responsive' alt='' />*/}

        </div>

    );

}

export default Header;
